import { render, staticRenderFns } from "./HotelReviewModal.vue?vue&type=template&id=ff2c5848&"
import script from "./HotelReviewModal.vue?vue&type=script&lang=js&"
export * from "./HotelReviewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports